type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const developedByLink = 'https://techzaa.getappui.com/'

export const developedBy = 'Coderthemes'

export const contactUs = 'techzaastudio@gmail.com'

export const buyLink = ''

export const basePath = ''

export const DEFAULT_PAGE_TITLE = ' TransExpress :: ISO'

// Replace the URL's value in env with your backend's URL or if you're using nextjs's API, add the server's origin URL
export const API_BASE_PATH = ''

export const colorVariants = [
  'secondary',
  'primary',
  'success',
  'info',
  'warning',
  'danger',
  'secondary',
  'dark',
  'purple',
  'pink',
  'orange',
  'light',
  'link',
]
